<div class="icon_header">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class="content">
    <h4>Select Location</h4>
    <h3>Upload your files</h3>
    <input #uploader type='file' style='display:none;' (change)="fileUploaded($event)">
    <app-button-primary text="From computer" (click)="uploader.click()"></app-button-primary>
    <app-button-secondary buttonText="From product files" [isText]="true" *ngIf="data" (click)="openPreuploads()"></app-button-secondary>
</div>